import { useApi } from "hooks"
import useSession from "hooks/useSession";
import { useQuery } from "@tanstack/react-query";

const useGetProfileMinimal = ({ userID }) => {

  const { isLoggedIn } = useSession()
  const { apiFetch } = useApi()

  const url = `/users/profile/minimal/${userID}`;

  const getProfileMinimal = () => {
    return apiFetch({ url })
      .then( res => res.data)
  }

  const options = {
    staleTime: 60000 * 10, // 10 min
    cacheTime: 60000 * 120, // 2 hs
    placeholderData: null,
    enabled: isLoggedIn && !!userID,
  }

  return useQuery(['profileMinimal', userID], getProfileMinimal, options)
}

export default useGetProfileMinimal